import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Button,
	Checkbox,
	FormControlLabel,
	Icon,
	Menu,
	MenuItem
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { ExpandMore } from '@material-ui/icons'
import clsx from 'clsx'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'

import { STATUS_ID } from '../../../../utils'

const useStyles = makeStyles((theme) => ({
	headerButton: {
		fontFamily: 'Nunito',
		fontWeight: '700',
		'& .MuiButton-label': {
			lineHeight: '19px',
			fontSize: '14px'
		}
	},
	filterButton: {
		zIndex: 1,
		'&.Mui-disabled': {
			'& .fas.fa-sliders-h': {
				color: 'rgba(0, 0, 0, 0.26)'
			}
		}
	},
	filterIcon: {
		fontSize: 19,
		color: '#777679',
		marginRight: 8
	},
	filterButtonLabel: {
		alignItems: 'center'
	},
	accordianExpanded: {
		margin: '0px !important'
	},
	check: {
		padding: 0,
		marginRight: 16,
		height: 18,
		width: 18,
		color: '#D0CFD2'
	},
	formLabel: {
		marginLeft: 0
	},
	summary: {
		minHeight: 54,
		'&.Mui-expanded': {
			minHeight: 54
		}
	},
	summaryContent: {
		margin: 0,
		'&.Mui-expanded': {
			margin: 0
		}
	},
	accordian: {
		boxShadow: 'none !important',
		'&::before': {
			height: 0
		}
	},
	detailsRoot: {
		flexDirection: 'column',
		backgroundColor: '#F9F9F9',
		padding: '8px 0px'
	},
	labelRoot: {
		paddingTop: 0,
		paddingBottom: 0,
		padding: '0px 16px 0px 56px'
	},
	label: {
		fontSize: '16px',
		fontWeight: 600,
		lineHeight: '22px',
		textTransform: 'capitalize'
	},
	accordianItem: {
		padding: '8px 0px'
	}
}))

const notesFilters = {
	alert_status: [
		{ value: 'Open', label: 'Open' },
		{ value: 'In Progress', label: 'In Progress' },
		{ value: 'Closed', label: 'Closed' }
	],
	tags: [
		{ value: 'raise_alert', label: 'Raise Alert' },
		{ value: 'check_out', label: 'Check Out' },
		{ value: 'client_comment', label: 'Client Comment' }
	],
	alert_type: [
		{ value: 'staff_note', label: 'Staff Note' },
		{ value: 'meal_alert', label: 'Meal Alert' },
		{ value: 'body_check_alert_entry', label: 'Entry Body Check Issues' },
		{ value: 'body_check_alert_exit', label: 'Exit Body Check Issues' },
		{ value: 'addon_alert', label: 'Enrichment Alert' }
	],
	appointment_type: [
		{ value: 'boarding', label: 'Boarding' },
		{ value: 'daycare', label: 'Daycare' },
		{ value: 'compatibility_session', label: 'Compatibility Session' }
	],
	appointment_status: [
		{ value: STATUS_ID.Approved, label: 'Approved' },
		{ value: STATUS_ID.InProgress, label: 'In-Progress' },
		{ value: STATUS_ID.Completed, label: 'Completed' },
		{ value: STATUS_ID.Cancelled, label: 'Cancelled' }
	]
}

export const FilterButton = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const [isFilterOpen, setIsFilterOpen] = useState(false)
	const [filterMenuEl, setFilterMenuEl] = useState(null)

	const { selectedFilters, setFilters } = props
	const filters = notesFilters

	const handleClick = (event) => {
		setFilterMenuEl(event.currentTarget)
		setIsFilterOpen(true)
	}

	return (
		<div>
			<Button
				className={clsx(classes.headerButton, classes.filterButton)}
				onClick={handleClick}
				variant="outlined"
				size="large"
				classes={{
					label: classes.filterButtonLabel
				}}
				aria-controls="filter-menu"
				aria-haspopup="true">
				<Icon className={clsx(classes.filterIcon, 'fas fa-sliders-h')} />
				{selectedFilters.length ? selectedFilters.length : ''}
			</Button>
			<Menu
				open={isFilterOpen}
				id="filter-menu"
				anchorEl={filterMenuEl}
				getContentAnchorEl={null}
				anchorOrigin={{
					vertical: 30,
					horizontal: -280
				}}
				onClose={() => setIsFilterOpen(false)}
				MenuListProps={{
					style: {
						padding: 0
					}
				}}
				PaperProps={{
					style: {
						width: 339,
						borderRadius: 10,
						maxHeight: 454
					}
				}}>
				{filters
					? Object.keys(filters).map((f) => {
							let filter = filters[f]

							let label = f.split('_').join(' ')
							label = label.charAt(0).toUpperCase() + label.slice(1)
							let checked = filter.some((o) => selectedFilters.find((fil) => fil.value === o.value))

							if (Array.isArray(filter)) {
								return (
									<Accordion
										classes={{
											root: classes.accordian,
											expanded: classes.accordianExpanded
										}}>
										<AccordionSummary
											expandIcon={<ExpandMore />}
											classes={{
												root: classes.summary,
												content: classes.summaryContent
											}}
											onClick={(e) => e.stopPropagation()}
											key={f}
											aria-label="Expand"
											aria-controls="additional-actions1-content"
											id="additional-actions1-header">
											<FormControlLabel
												style={{
													marginLeft: 0
												}}
												classes={{
													label: classes.label
												}}
												onClick={(e) => e.stopPropagation()}
												control={
													<Checkbox
														className={classes.check}
														checked={checked}
														onChange={(e) => {
															e.stopPropagation()
															let fils
															if (checked) {
																let getRid = filter
																fils = selectedFilters.filter(
																	(fil) =>
																		!getRid.find(
																			(fi) => fi.value === fil.value
																		)
																)
															} else {
																fils = [...selectedFilters, ...filter]
															}
															setFilters(fils)
														}}
													/>
												}
												label={label}
											/>
										</AccordionSummary>
										<AccordionDetails
											classes={{
												root: classes.detailsRoot
											}}>
											{filter.map((o) => {
												let selected = selectedFilters.find((fil) => fil.value === o.value)
												return (
													<MenuItem
														classes={{
															root: classes.accordianItem
														}}
														key={o.value}>
														<FormControlLabel
															className={classes.formLabel}
															classes={{
																root: classes.labelRoot,
																label: classes.label
															}}
															control={
																<Checkbox
																	className={classes.check}
																	checked={selected ? true : false}
																	onChange={(e) => {
																		e.stopPropagation()
																		let find = selectedFilters.find(
																			(fil) => fil.value === o.value
																		)
																		let filts
																		if (find) {
																			filts = selectedFilters.filter(
																				(fil) => fil.value !== o.value
																			)
																		} else {
																			filts = [...selectedFilters, o]
																		}
																		setFilters(filts)
																	}}
																/>
															}
															label={o.label}
														/>
													</MenuItem>
												)
											})}
										</AccordionDetails>
									</Accordion>
								)
							}
					  })
					: null}
			</Menu>
		</div>
	)
}
